module.exports = __webpack_public_path__ + "officialStatic/img/product-gap.609f8bd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/product-gap.png
// module id = YO16
// module chunks = 0